import {
  RENT_SAVE,
  RESERVE_UPDATE,
  RESERVE_SAVE,
  RENT_UPDATE,
  RENT_LIST,
  RESERVE_LIST,
  RENT_ARCHIVE_LIST,
  ADD_RENTS_ARCHIVE_TO_LIST,
  INSTRUMENT_LIST,
  INSTRUMENT_SUBTYPES,
  RENT_ACCRUAL_LIST,
  INSTRUMENT_CATEGORIES,
  INSTRUMENT_ADD_LIST,
  RENT_CONTINUE_SAVE,
  RENT_CONTINUE_UPDATE,
  RENT_CONTINUE_CLEAR,
  RENT_EXIT_SAVE,
  RENT_EXIT_UPDATE,
  INSTRUMENT_SET_STOCK,
  RENT_STATISTIC,
  RENT_CLEAR,
  RENT_TABLE_LIST,
  RENT_EXIT_CLEAR,
  ADD_RESERVES_TO_LIST,
  ADD_RENTS_TO_LIST,
  RENT_TABLE_LIST_HAS_NEXT,
  RENT_ACT_STATUSES,
  RENT_STATISTIC_REJECT_REASON,
} from './actionTypes';
import { Stock } from 'store/stock/actions';
import { balanceApi } from 'helpers/api/balance';
import { transferApi } from 'helpers/api/transfer';
import { getUUID } from 'helpers/utils';

export const RentContinue = {
  saveRent: (payload) => ({
    type: RENT_CONTINUE_SAVE,
    payload,
  }),

  updateRent: (payload) => ({
    type: RENT_CONTINUE_UPDATE,
    payload,
  }),
  clearRent: (payload) => ({
    type: RENT_CONTINUE_CLEAR,
    payload,
  }),

  getRent: (rentId) => async (dispatch) => {
    dispatch(Stock.getStockList());

    transferApi.getTransferAct(rentId).then(({ data } = {}) => {
      const instruments = data.chosenItem.map((item) => ({
        ...item,
        AdditionalRentTerm: 1,
        oldAdditionalRentTerm: item.AdditionalRentTerm,
      }));

      dispatch(
        RentContinue.saveRent({
          ...data,
          instruments,
          client: data.clientID,
          address: data.AddrExp,
          fine: [],
          discount: [],
          agr: data.agreement || null,
        })
      );
    });
  },
};

export const RentExit = {
  saveRent: (payload) => ({
    type: RENT_EXIT_SAVE,
    payload,
  }),

  clearRent: (payload) => ({
    type: RENT_EXIT_CLEAR,
    payload,
  }),

  updateRent: (payload) => ({
    type: RENT_EXIT_UPDATE,
    payload,
  }),

  getRent: (rentId) => async (dispatch) => {
    dispatch(Stock.getStockList());

    transferApi.getTransferAct(rentId).then(({ data } = {}) => {
      const instruments = data.chosenItem.map((item) => ({
        ...item,
        oldQuantity: item.quantity - item.quantityOUT || 0,
        quantityOUT: item.quantity - item.quantityOUT,
      }));

      dispatch(
        RentExit.saveRent({
          ...data,
          instruments,
          client: data.clientID,
          address: data.AddrExp,
          comment: '',
          fine: [],
          discount: [],
          agr: data.agreement || null,
        })
      );
    });
  },
};

export const Rent = {
  saveRent: (payload) => ({
    type: RENT_SAVE,
    payload,
  }),

  clearRent: (payload) => ({
    type: RENT_CLEAR,
    payload,
  }),

  updateRent: (payload) => ({
    type: RENT_UPDATE,
    payload,
  }),

  getAccrualList: () => async (dispatch) => {
    transferApi.getAccrualSubTypes().then(({ data } = {}) => {
      dispatch(Rent.setAccrualList(data));
    });
  },

  setAccrualList: (payload) => ({
    type: RENT_ACCRUAL_LIST,
    payload,
  }),

  getStatisticList: (query = {}) => async (dispatch) => {
    return transferApi
      .statistic(query)
      .then(({ data } = {}) => {
        dispatch(Rent.setRentStatisticList(data));
      })
      .catch(() => {
        dispatch(Rent.setRentStatisticList(null));
      });
  },

  getStatisticRejectReason: (query = {}) => async (dispatch) => {
    return transferApi
      .statisticRejectReason(query)
      .then(({ data } = {}) => {
        dispatch(Rent.setRentStatisticRejectReasonList(data));
      })
      .catch(() => {
        dispatch(Rent.setRentStatisticRejectReasonList(null));
      });
  },

  addRentsToList: (query) => async (dispatch) => {
    return transferApi
      .getTransferActSorted(query)
      .then(({ data: { results } }) => {
        if (!Array.isArray(results)) {
          throw new Error('Retrieved data is not array!');
        }

        const lists = {
          rent: [],
          reserve: [],
          archive: [],
        };

        results.forEach((act) => {
          if (act.status === 'Резервация' || act.status === 'Резерв') {
            lists.reserve.push(act);
          } else if (act.status === 'Архив') {
            lists.archive.push(act);
          } else if (act.status !== '') {
            lists.rent.push(act);
          }
        });

        dispatch(Rent.addRentsList(lists.rent));
        dispatch(Rent.addReservesList(lists.reserve));
        dispatch(Rent.addRentArchiveList(lists.archive));
        return results;
      })
      .catch(() => {
        dispatch(Rent.setRentList([]));
        dispatch(Rent.setRentArchiveList([]));
      });
  },

  getRentActStatuses: () => async (dispatch) => {
    transferApi.getTransferActStatuses().then((data) => {
      if (Array.isArray(data?.data)) {
        dispatch(Rent.setRentActStatuses(data?.data));
      }
    });
  },

  getUpdatedList: (query) => async (dispatch) => {
    transferApi
      .getTransferActSorted(query)
      .then(({ data: { results } }) => {
        if (!Array.isArray(results)) {
          throw new Error('Retrieved data is not array!');
        }

        const lists = {
          rent: [],
          reserve: [],
          archive: [],
        };

        results.forEach((act) => {
          /// Ебанутая система статусов
          if (act.status === 'Резервация' || act.status === 'Резерв') {
            lists.reserve.push(act);
          } else if (act.status === 'Архив') {
            lists.archive.push(act);
          } else if (act.status !== '') {
            lists.rent.push(act);
          }
        });

        dispatch(Rent.setRentList(lists.rent));
        dispatch(Reservation.setReserveList(lists.reserve));
        dispatch(Rent.setRentArchiveList(lists.archive));
      })
      .catch(() => {
        dispatch(Rent.setRentList([]));
        dispatch(Reservation.setReserveList([]));
        dispatch(Rent.setRentArchiveList([]));
      });
  },

  addToListAsTable: (query) => async (dispatch, getState) => {
    transferApi.getTransferActAsTable(query).then(({ data: { results, next } }) => {
      if (!Array.isArray(results)) {
        throw new Error('Retrieved data is not array!');
      }
      const tableList = getState().transferAct.tableList;
      dispatch(Rent.setRentTableListHasNext(next !== null));
      dispatch(Rent.setRentTableList([...tableList, ...results]));
    });
  },

  getListAsTable: (query) => async (dispatch) => {
    dispatch(Rent.setRentTableList(null));
    transferApi.getTransferActAsTable(query).then((apiResult) => {
      if (!apiResult) {
        return;
      }
      const {
        data: { results, next },
      } = apiResult;
      dispatch(Rent.setRentTableListHasNext(next !== null));
      dispatch(Rent.setRentTableList(results));
    });
  },

  getSortedList: (query) => async (dispatch) => {
    dispatch(Rent.setRentList(null));
    dispatch(Reservation.setReserveList(null));
    dispatch(Rent.setRentArchiveList(null));

    transferApi
      .getTransferActSorted(query)
      .then(({ data: { results } }) => {
        if (!Array.isArray(results)) {
          throw new Error('Retrieved data is not array!');
        }

        const lists = {
          rent: [],
          reserve: [],
          archive: [],
        };

        results.forEach((act) => {
          /// Ебанутая система статусов
          if (act.status === 'Резервация' || act.status === 'Резерв') {
            lists.reserve.push(act);
          } else if (act.status === 'Архив') {
            lists.archive.push(act);
          } else if (act.status !== '') {
            lists.rent.push(act);
          }
        });

        dispatch(Rent.setRentList(lists.rent));
        dispatch(Reservation.setReserveList(lists.reserve));
        dispatch(Rent.setRentArchiveList(lists.archive));
      })
      .catch(() => {
        dispatch(Rent.setRentList([]));
        dispatch(Reservation.setReserveList([]));
        dispatch(Rent.setRentArchiveList([]));
      });
  },

  getRentArchiveList: (query) => async (dispatch) => {
    dispatch(Rent.setRentArchiveList(null));

    transferApi
      .getRentArchiveList(query)
      .then(({ data } = {}) => {
        dispatch(Rent.setRentArchiveList(data.results));
      })
      .catch(() => dispatch(Rent.setRentArchiveList([])));
  },

  getRent: (rentId) => async (dispatch) => {
    transferApi.getTransferAct(rentId).then(({ data } = {}) => {
      const accruals = data.accruals;
      const accrualFine = accruals
        .filter((acc) => acc.type === 'Штраф')
        .map((elem) => ({ ...elem, fronEndID: getUUID() }));
      const accrualDiscount = accruals
        .filter((acc) => acc.type === 'Скидка')
        .map((elem) => ({ ...elem, fronEndID: getUUID() }));

      dispatch(
        Rent.saveRent({
          ...data,
          instruments: data.chosenItem,
          client: data.clientID,
          address: data.AddrExp,
          fine: accrualFine,
          discount: accrualDiscount,
          agr: data.agreement || null,
        })
      );
    });
  },

  updateTransfer: (rentId, data) => async (dispatch) => {
    return transferApi.updateTransferAct(rentId, data).then(() => {
      dispatch(Rent.updateRent({ ...data }));
    });
  },

  setRentList: (payload) => ({
    type: RENT_LIST,
    payload,
  }),

  setRentActStatuses: (payload) => ({
    type: RENT_ACT_STATUSES,
    payload,
  }),

  setRentTableListHasNext: (payload) => ({
    type: RENT_TABLE_LIST_HAS_NEXT,
    payload,
  }),

  setRentTableList: (payload) => ({
    type: RENT_TABLE_LIST,
    payload,
  }),

  setRentArchiveList: (payload) => ({
    type: RENT_ARCHIVE_LIST,
    payload,
  }),

  addRentArchiveList: (payload) => ({
    type: ADD_RENTS_ARCHIVE_TO_LIST,
    payload,
  }),

  addReservesList: (payload) => ({
    type: ADD_RESERVES_TO_LIST,
    payload,
  }),

  addRentsList: (payload) => ({
    type: ADD_RENTS_TO_LIST,
    payload,
  }),

  setRentStatisticList: (payload) => ({
    type: RENT_STATISTIC,
    payload,
  }),
  setRentStatisticRejectReasonList: (payload) => ({
    type: RENT_STATISTIC_REJECT_REASON,
    payload,
  }),
};

export const Reservation = {
  saveReserve: (payload) => ({
    type: RESERVE_SAVE,
    payload,
  }),

  updateReserve: (payload) => ({
    type: RESERVE_UPDATE,
    payload,
  }),

  getReservation: (reserveId) => async (dispatch) => {
    transferApi.getTransferAct(reserveId).then(({ data } = {}) => {
      dispatch(
        Reservation.saveReserve({
          ...data,
          instruments: data.chosenItem,
          time: data.endDateTime,
          client: data.clientID,
          bonus: null,
        })
      );
    });
  },

  updateIsApproved: (reserveId, isApproved) => async (dispatch) => {
    const updateAct = { isApproved };
    return transferApi.updateTransferAct(reserveId, updateAct).then(() => {
      dispatch(
        Reservation.updateReserve({
          isApproved,
        })
      );
    });
  },

  updateisSendViberMessage: (reserveId) => async (dispatch) => {
    const updateAct = { isSendViberMessage: false };
    return transferApi.updateTransferAct(reserveId, updateAct).then(() => {
      dispatch(Reservation.updateReserve(updateAct));
    });
  },

  getReserveList: (query) => async (dispatch) => {
    dispatch(Reservation.setReserveList(null));

    transferApi
      .getReservationList(query)
      .then(({ data } = {}) => {
        dispatch(Reservation.setReserveList(data.results));
      })
      .catch(() => dispatch(Reservation.setReserveList([])));
  },

  setReserveList: (payload) => ({
    type: RESERVE_LIST,
    payload,
  }),
};

export const Instrument = {
  getBalanceList: (query) => async (dispatch) => {
    dispatch(Instrument.saveBalanceList(null));
    if (query.stockID) {
      dispatch(Instrument.setStock(query.stockID));
    }
    balanceApi
      .getBalanceList(query)
      .then(({ data } = {}) => {
        dispatch(Instrument.saveBalanceList(data.results));
      })
      .catch(() => dispatch(Instrument.saveCategoriesList([])));
  },

  appendBalanceList: (query) => async (dispatch) => {
    balanceApi.getBalanceList(query).then(({ data } = {}) => {
      dispatch(Instrument.addBalanceList(data.results));
    });
  },

  getCategories: () => async (dispatch) => {
    dispatch(Instrument.saveCategoriesList(null));

    balanceApi
      .getCategories()
      .then(({ data } = {}) => {
        dispatch(Instrument.saveCategoriesList(data));
      })
      .catch(() => dispatch(Instrument.saveCategoriesList([])));
  },

  getSubTypes: () => async (dispatch) => {
    balanceApi
      .getSubTypes()
      .then(({ data } = {}) => {
        dispatch(Instrument.saveSubTypes(data));
      })
      .catch(() => dispatch(Instrument.saveSubTypes([])));
  },

  setStock: (payload) => ({
    type: INSTRUMENT_SET_STOCK,
    payload,
  }),

  saveCategoriesList: (payload) => ({
    type: INSTRUMENT_CATEGORIES,
    payload,
  }),

  saveSubTypes: (payload) => ({
    type: INSTRUMENT_SUBTYPES,
    payload,
  }),

  saveBalanceList: (payload) => ({
    type: INSTRUMENT_LIST,
    payload,
  }),

  addBalanceList: (payload) => ({
    type: INSTRUMENT_ADD_LIST,
    payload,
  }),
};
